<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<ng-container *ngIf="!hasPendingData && data != null">
    <div class="table-responsive">
        <table class="table table-striped table-sm table-bordered-no-cells">
            <thead class="thead-light">
                <tr>
                    <th rowspan="2">{{ i18n._53_NAME | translate }}</th>
                    <th
                        [attr.colspan]="data.metrics.length"
                        class="text-center"
                    >
                        {{ i18n._527_METRICS | translate }}
                    </th>
                </tr>
                <tr>
                    <th *ngFor="let i of data.metrics">{{ i.name }}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{{ data.user.username }}</td>
                    <td *ngFor="let j of data.user.values">
                        {{
                            j && j.length !== 0 && j[0]?.actual != null
                                ? (j[0].actual | number: '1.0-0')
                                : '-'
                        }}
                    </td>
                </tr>
                <tr>
                    <td>{{ i18n._67_SUPERGROUP | translate }}</td>
                    <td *ngFor="let j of data.superGroup.values">
                        {{
                            j && j.length !== 0 && j[0]?.actual != null
                                ? (j[0].actual | number: '1.0-0')
                                : '-'
                        }}
                    </td>
                </tr>
                <tr *ngFor="let i of data.team">
                    <td>{{ i.username }}</td>
                    <td *ngFor="let j of i.values">
                        {{
                            j.actual == null
                                ? '-'
                                : (j.actual | number: '1.0-0')
                        }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>
